/**
 * Consent-gated analytics loader. Default production: no-op.
 * Session recording is always disabled.
 */

import { getConsent, onConsentChange } from "./consent";

let initialized = false;
let listening = false;

function envAllowsAnalytics() {
  return process.env.REACT_APP_ENABLE_ANALYTICS === "true";
}

/**
 * Dynamically inject PostHog only when env + consent.analytics allow it.
 * No-op if keys missing or already initialized.
 */
export function initAnalyticsIfAllowed() {
  if (typeof window === "undefined") return;
  if (!envAllowsAnalytics()) return;
  if (initialized) return;

  const consent = getConsent();
  if (!consent?.analytics) return;

  const key = process.env.REACT_APP_POSTHOG_KEY;
  const host = process.env.REACT_APP_POSTHOG_HOST;
  if (!key || !host) return;

  initialized = true;

  // Minimal stub + async loader (never in index.html).
  !(function (t, e) {
    var o, n, p, r;
    e.__SV ||
      ((window.posthog = e),
      (e._i = []),
      (e.init = function (i, s, a) {
        function g(t, e) {
          var o = e.split(".");
          2 == o.length && ((t = t[o[0]]), (e = o[1]));
          t[e] = function () {
            t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
          };
        }
        ((p = t.createElement("script")).type = "text/javascript"),
          (p.crossOrigin = "anonymous"),
          (p.async = !0),
          (p.src =
            s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") +
            "/static/array.js"),
          (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(p, r);
        var u = e;
        for (
          void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
            u.people = u.people || [],
            u.toString = function (t) {
              var e = "posthog";
              return (
                "posthog" !== a && (e += "." + a),
                t || (e += " (stub)"),
                e
              );
            },
            u.people.toString = function () {
              return u.toString(1) + ".people (stub)";
            },
            (o =
              "init capture identify reset register register_once unregister get_distinct_id opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing".split(
                " ",
              )),
            (n = 0);
          n < o.length;
          n++
        )
          g(u, o[n]);
        e._i.push([i, s, a]);
      }),
      (e.__SV = 1));
  })(document, window.posthog || []);

  window.posthog.init(key, {
    api_host: host,
    person_profiles: "identified_only",
    // Session recording is forbidden in the current legal implementation.
    disable_session_recording: true,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "*",
    },
  });

  if (typeof window.posthog.stopSessionRecording === "function") {
    window.posthog.stopSessionRecording();
  }
}

/** Listen for consent changes and init once analytics is allowed. Call after mount. */
export function onConsentMaybeInit() {
  if (typeof window === "undefined") return;
  initAnalyticsIfAllowed();
  if (listening) return;
  listening = true;
  onConsentChange(() => {
    initAnalyticsIfAllowed();
  });
}
